<template>
  <div class="voordelen container">
    <div class="headline">
      <hr>
      <h3 class="headline-title">Voordelen bij Twelve Pools</h3>
    </div>
    <div class="context-outer">
      <div class="single-item">
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M35.75 29.3333C35.75 30.3472 34.9305 31.1667 33.9167 31.1667H30.25C29.2362 31.1667 28.4167 30.3472 28.4167 29.3333C28.4167 28.3195 29.2362 27.5 30.25 27.5H33.9167C34.9305 27.5 35.75 28.3195 35.75 29.3333ZM44 27.5V36.6667C44 40.711 40.711 44 36.6667 44H7.33333C3.289 44 0 40.711 0 36.6667V27.5C0 23.4557 3.289 20.1667 7.33333 20.1667H9.16667V7.33333C9.16667 3.289 12.4557 0 16.5 0H27.5C31.5443 0 34.8333 3.289 34.8333 7.33333V20.1667H36.6667C40.711 20.1667 44 23.4557 44 27.5ZM12.8333 20.1667H31.1667V7.33333C31.1667 5.31117 29.5222 3.66667 27.5 3.66667H16.5C14.4778 3.66667 12.8333 5.31117 12.8333 7.33333V20.1667ZM7.33333 40.3333H20.1667V23.8333H7.33333C5.31117 23.8333 3.66667 25.4778 3.66667 27.5V36.6667C3.66667 38.6888 5.31117 40.3333 7.33333 40.3333ZM40.3333 27.5C40.3333 25.4778 38.6888 23.8333 36.6667 23.8333H23.8333V40.3333H36.6667C38.6888 40.3333 40.3333 38.6888 40.3333 36.6667V27.5ZM13.75 27.5H10.0833C9.0695 27.5 8.25 28.3195 8.25 29.3333C8.25 30.3472 9.0695 31.1667 10.0833 31.1667H13.75C14.7638 31.1667 15.5833 30.3472 15.5833 29.3333C15.5833 28.3195 14.7638 27.5 13.75 27.5ZM25.6667 9.16667C25.6667 8.15283 24.8472 7.33333 23.8333 7.33333H20.1667C19.1528 7.33333 18.3333 8.15283 18.3333 9.16667C18.3333 10.1805 19.1528 11 20.1667 11H23.8333C24.8472 11 25.6667 10.1805 25.6667 9.16667Z"
              fill="#E5CE8B"/>
        </svg>
        <div class="text-side">
          <h5>Bouwkundige zwembaden</h5>
          <p>Twelve Pools plaatst bouwkundige zwembaden, op maat ontworpen en conform alle veiligheids- en sabilitietsnormen.</p>
        </div>
      </div>
      <div class="single-item">
        <svg width="30" height="44" viewBox="0 0 30 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.6066 44C13.0059 43.9979 12.4129 43.8653 11.8686 43.6114C10.9794 43.2154 10.2653 42.5086 9.86026 41.6236C9.4552 40.7385 9.38704 39.7361 9.66856 38.8044L12.5304 29.3334H5.7874C4.9283 29.3344 4.08091 29.1342 3.31314 28.7487C2.54536 28.3633 1.87855 27.8034 1.36615 27.1138C0.853755 26.4242 0.510012 25.6242 0.362475 24.7779C0.214938 23.9316 0.26771 23.0625 0.516561 22.2402L6.06056 3.90686C6.3985 2.77291 7.09509 1.77914 8.04579 1.07471C8.99649 0.370282 10.15 -0.00681069 11.3332 3.04286e-05H18.1037C18.8733 0.00067419 19.6312 0.187628 20.3128 0.544915C20.9944 0.902202 21.5793 1.4192 22.0177 2.05172C22.456 2.68424 22.7346 3.41349 22.8298 4.17713C22.925 4.94077 22.8339 5.7161 22.5642 6.43686L19.4787 14.6667H24.1666C25.1658 14.6666 26.1462 14.9388 27.0025 15.4539C27.8587 15.9691 28.5584 16.7078 29.0264 17.5907C29.4945 18.4736 29.7131 19.4673 29.6589 20.4651C29.6047 21.4629 29.2797 22.427 28.7187 23.254L16.9854 42.1374C16.6227 42.7054 16.1234 43.1735 15.5331 43.4989C14.9429 43.8243 14.2805 43.9966 13.6066 44ZM11.3332 3.6667C10.9395 3.66631 10.5561 3.79269 10.2398 4.02711C9.92351 4.26154 9.69107 4.59157 9.57689 4.96836L4.0329 23.3017C3.94989 23.5756 3.93217 23.8652 3.98117 24.1472C4.03016 24.4292 4.14451 24.6958 4.31504 24.9257C4.48558 25.1556 4.70757 25.3423 4.96325 25.471C5.21892 25.5997 5.50117 25.6667 5.7874 25.6667H14.9999C15.2861 25.6667 15.5684 25.7337 15.824 25.8624C16.0797 25.9911 16.3017 26.1778 16.4722 26.4077C16.6428 26.6376 16.7571 26.9042 16.8061 27.1862C16.8551 27.4682 16.8374 27.7578 16.7544 28.0317L13.1849 39.842C13.1684 39.8855 13.1611 39.9319 13.1635 39.9783C13.1658 40.0247 13.1778 40.0702 13.1987 40.1117C13.2196 40.1532 13.2488 40.19 13.2846 40.2196C13.3204 40.2493 13.362 40.2711 13.4067 40.2839C13.4473 40.3098 13.4928 40.327 13.5404 40.3344C13.5879 40.3417 13.6365 40.3389 13.683 40.3263C13.7295 40.3137 13.7728 40.2915 13.8101 40.2612C13.8475 40.2308 13.8781 40.1929 13.8999 40.15L25.6332 21.2667C25.8384 20.9884 25.9607 20.6578 25.986 20.3129C26.0113 19.9681 25.9386 19.6231 25.7762 19.3179C25.6258 19.0205 25.3955 18.7709 25.1112 18.597C24.8269 18.4231 24.4998 18.3319 24.1666 18.3334H16.8332C16.5369 18.3335 16.245 18.2619 15.9824 18.1246C15.7199 17.9873 15.4945 17.7883 15.3256 17.5449C15.1567 17.3014 15.0494 17.0206 15.0128 16.7266C14.9762 16.4325 15.0114 16.134 15.1154 15.8565L19.1304 5.14986C19.1921 4.98387 19.2128 4.80543 19.1907 4.62972C19.1687 4.45401 19.1045 4.28622 19.0037 4.14062C18.903 3.99501 18.7685 3.87589 18.6118 3.79338C18.4551 3.71087 18.2808 3.66741 18.1037 3.6667H11.3332Z" fill="#E5CE8B"/>
        </svg>
        <div class="text-side">
          <h5>Prefab zwembaden</h5>
          <p>Ook prefab zwembaden worden door Twelve Pools geplaatst, die in grootte en ontwerp kunnen worden aangepast naar de specifieke behoeften van de klant.</p>
        </div>
      </div>
      <div class="single-item">
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_44_502)">
            <path d="M44.0001 20.6195C43.735 16.3295 42.2202 12.2109 39.6426 8.77144C37.065 5.33195 33.5373 2.72193 29.4943 1.26315C25.4512 -0.195626 21.0697 -0.439393 16.8898 0.561904C12.7099 1.5632 8.91441 3.76579 5.97119 6.89813C3.02798 10.0305 1.06572 13.9556 0.326343 18.1897C-0.413038 22.4238 0.102776 26.7817 1.8102 30.7261C3.51761 34.6706 6.342 38.0292 9.93515 40.3879C13.5283 42.7465 17.7331 44.0022 22.0313 44H34.8335C37.2639 43.9976 39.594 43.031 41.3126 41.3125C43.0311 39.5939 43.9977 37.2637 44.0001 34.8333V20.6195ZM40.3335 34.8333C40.3335 36.292 39.754 37.691 38.7225 38.7224C37.6911 39.7539 36.2921 40.3333 34.8335 40.3333H22.0313C19.4443 40.3322 16.8867 39.7858 14.5251 38.7297C12.1635 37.6737 10.051 36.1318 8.32528 34.2045C6.59127 32.2782 5.28916 30.0034 4.50625 27.5326C3.72335 25.0619 3.47776 22.4523 3.78595 19.8788C4.27258 15.8197 6.0963 12.038 8.96959 9.12986C11.8429 6.22171 15.6023 4.35253 19.6553 3.81699C20.4459 3.71791 21.2418 3.6677 22.0386 3.66666C26.3112 3.65501 30.4514 5.14782 33.7334 7.88333C35.6502 9.47639 37.2236 11.4421 38.3581 13.6613C39.4926 15.8805 40.1646 18.307 40.3335 20.7937V34.8333Z" fill="#E5CE8B"/>
            <path d="M14.6667 16.5H22C22.4863 16.5 22.9526 16.3068 23.2964 15.963C23.6402 15.6192 23.8334 15.1529 23.8334 14.6666C23.8334 14.1804 23.6402 13.7141 23.2964 13.3703C22.9526 13.0265 22.4863 12.8333 22 12.8333H14.6667C14.1805 12.8333 13.7142 13.0265 13.3703 13.3703C13.0265 13.7141 12.8334 14.1804 12.8334 14.6666C12.8334 15.1529 13.0265 15.6192 13.3703 15.963C13.7142 16.3068 14.1805 16.5 14.6667 16.5Z" fill="#E5CE8B"/>
            <path d="M29.3334 20.1667H14.6667C14.1805 20.1667 13.7142 20.3598 13.3703 20.7037C13.0265 21.0475 12.8334 21.5138 12.8334 22C12.8334 22.4863 13.0265 22.9526 13.3703 23.2964C13.7142 23.6402 14.1805 23.8334 14.6667 23.8334H29.3334C29.8196 23.8334 30.2859 23.6402 30.6297 23.2964C30.9736 22.9526 31.1667 22.4863 31.1667 22C31.1667 21.5138 30.9736 21.0475 30.6297 20.7037C30.2859 20.3598 29.8196 20.1667 29.3334 20.1667Z" fill="#E5CE8B"/>
            <path d="M29.3334 27.5H14.6667C14.1805 27.5 13.7142 27.6932 13.3703 28.037C13.0265 28.3808 12.8334 28.8471 12.8334 29.3333C12.8334 29.8196 13.0265 30.2859 13.3703 30.6297C13.7142 30.9735 14.1805 31.1667 14.6667 31.1667H29.3334C29.8196 31.1667 30.2859 30.9735 30.6297 30.6297C30.9736 30.2859 31.1667 29.8196 31.1667 29.3333C31.1667 28.8471 30.9736 28.3808 30.6297 28.037C30.2859 27.6932 29.8196 27.5 29.3334 27.5Z" fill="#E5CE8B"/>
          </g>
          <defs>
            <clipPath id="clip0_44_502">
              <rect width="44" height="44" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <div class="text-side">
          <h5>Renovatie</h5>
          <p>Op zoek naar een nieuwe uitstraling of technologie van uw bestaande zwembad? Twelve Pools biedt u de renovatie service, op maat en volledig naar wens!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

$gold: #D6AD60;

.voordelen {
  margin-top: 120px;

  .headline {
    display: flex;
    align-items: center;
    gap: 20px;

    hr {
      background-color: $gold;
      border: none;
      height: 3px;
      width: 150px;
      margin: 0;
      @media (max-width: 950px) {
        width: 100px;
      }

      @media (max-width: 650px) {
        display: none;
      }
    }

    .headline-title {
    }
  }

  .context-outer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 50px;
    margin-top: 50px;
    @media (max-width: 950px) {
      grid-template-columns: 1fr;
    }
    .single-item {
      display: flex;
      gap: 30px;
      .text-side {
        h5 {
          color: $gold;
        }
      }
      svg {
        min-width: 70px;
        max-height: 100px;
      }
    }
  }
}
</style>

<script>
export default {
  name: 'Voordelen',
}
</script>
